import { FC } from 'react';
import { Helmet } from 'react-helmet';
import Logo from '@assets/images/logo.svg';

interface SEO {
    title: string, 
    description: string, 
    ogImage?: string, 
    ogUrl: string
}

const SEO: FC<SEO> = ({ title, description, ogImage=Logo, ogUrl }) => {
    return (
        <Helmet>
        <html lang={`ru`} />
        <title>{title} — АртКонс</title>
        <meta name="description" content={description} />
        <meta name="keywords" content="" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={ogUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:locale" content={'ru_RU'} />
        <meta property="og:site_name" content="АртКонс" />
        
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />

        <script type="application/ld+json">
        {`
        {
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "АртКонс",
            "url": "${ogUrl}",
            "logo": "${ogImage}",
            "description": "${description}"
        }
        `}
        </script>
        </Helmet>
    );
};

export default SEO;